import { CartService } from "@/services/CartService.js";

export const state = () => ({
  IdCart: null,
  Currency: {},
  Country: {},
  Total: {},
  Products: [],
  Discounts: {},
  Shipping: {},
});

export const mutations = {
  setAll(state, { data }) {
    state.IdCart = data.IdCart;
    state.Currency = data.Currency;
    state.Total = data.Total;
    state.Products = data.Products;
    state.Discounts = data.Discounts;
    state.Country = data.Country;
    state.Shipping = data.Shipping;
  },
  setSummary(state, { data }) {
    state.IdCart = data.IdCart;
    state.Currency = data.Currency;
    state.Total = data.Total;
  },
  clear(state) {
    state.IdCart = null;
    state.Currency = {};
    state.Country = {};
    state.Total = null;
    state.Products = [];
    state.Discounts = {};
    state.Shipping = {};
  },
};

let fetchCartSummaryPromise = null;
let fetchCartPromise = null;

export const actions = {
  fetchCartSummary(
    { commit, rootState },
    { countryIsoCode, onSuccess = () => {}, onError = () => {} } = {}
  ) {
    if (fetchCartSummaryPromise) {
      return fetchCartSummaryPromise.then(onSuccess).catch(onError);
    }
    const cartService = new CartService({ http: this.$http, auth: this.$auth });
    if (!countryIsoCode) {
      countryIsoCode =
        rootState.checkout?.shippingAddress?.CountryIsoCode ||
        rootState.checkout?.shippingAddress?.Country?.IsoCode ||
        this.$localisation.appCountryIsoCode;
    }
    fetchCartSummaryPromise = cartService
      .getCartSummary({
        countryIsoCode,
        languageIsoCode: this.$i18n.locale,
        currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
      })
      .then((data) => {
        if (data && data.IdCart) {
          commit('setSummary', { data });
        }
        onSuccess(data);
        fetchCartSummaryPromise = null;
        return data;
      })
      .catch((err) => {
        fetchCartSummaryPromise = null;
        onError(err);
        throw err;
      });
    return fetchCartSummaryPromise;
  },
  fetchCart(
    { commit, rootState },
    { countryIsoCode, onSuccess = () => {}, onError = () => {} } = {}
  ) {
    if (fetchCartPromise) {
      return fetchCartPromise.then(onSuccess).catch(onError);
    }

    const cartService = new CartService({ http: this.$http, auth: this.$auth });

    if (!countryIsoCode) {
      countryIsoCode =
        rootState.checkout?.shippingAddress?.CountryIsoCode ||
        rootState.checkout?.shippingAddress?.Country?.IsoCode ||
        this.$localisation.appCountryIsoCode;
    }

    fetchCartPromise = cartService
      .getCartAll({
        languageIsoCode: this.$i18n.locale,
        currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
        countryIsoCode,
      })
      .then((data) => {
        if (data.IdCart) {
          commit('setAll', { data });
        }
        onSuccess(data);
        fetchCartPromise = null;
        return data;
      })
      .catch((err) => {
        fetchCartPromise = null;
        onError(err);
        throw err;
      });

    return fetchCartPromise;
  },
  
};
